export default "__VITE_ASSET__349447c8__"